import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FieldBody, ValidationMessage } from 'web-ui-components/lib/molecules/forms';
import { Input } from 'web-ui-components/lib/atoms/forms';
import styles from '../BacsPaymentStyles';
import { cleanIllegalBACSCharacters } from '../../../../helpers/fieldHelpers';
import withValidation from '../../../../containers/withValidation';
import { bacsReferenceMinLength } from '../../../../config';

class Reference extends Component {
	constructor(props) {
		super(props);
		this.handleOnBlur = this.handleOnBlur.bind(this);
		this.handleOnFocus = this.handleOnFocus.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.state = {
			reference: props.reference,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.value !== nextProps.reference) this.setState({ reference: nextProps.reference });
	}

	handleOnBlur() {
		const { reference } = this.state;
		if (reference !== this.props.reference) {
			this.props.handleReferenceChange(reference);
		}
		this.props.onBlur();
	}

	handleOnFocus() {
		const { reference } = this.state;
		const { onFocus } = this.props;
		if (onFocus) {
			this.props.onFocus(reference);
		}
	}

	handleChange(event) {
		this.setState({
			reference: cleanIllegalBACSCharacters(event.target.value),
		});
	}

	render() {
		const { id, maxLength, isValid, showValidation, invalidMessage, disabled, errorMessage } = this.props;
		const { reference } = this.state;
		const errorMsgVisible = !isValid && showValidation;
		return (
			<div>
				<FieldBody>
					<Input
						id={id}
						type="text"
						value={reference}
						onChange={this.handleChange}
						onBlur={this.handleOnBlur}
						onFocus={this.handleOnFocus}
						maxLength={maxLength}
						className={styles.main__input}
						autoComplete="off"
						disabled={disabled}
						data-test-id="reference"
					/>
				</FieldBody>
				{errorMsgVisible && (
					<div className={styles.main__validation}>
						<ValidationMessage hasIcon={false} value={errorMessage || invalidMessage} />
					</div>
				)}
			</div>
		);
	}
}

Reference.propTypes = {
	id: PropTypes.string.isRequired,
	reference: PropTypes.string,
	onBlur: PropTypes.func.isRequired,
	onFocus: PropTypes.func,
	maxLength: PropTypes.string.isRequired,
	isValid: PropTypes.bool,
	showValidation: PropTypes.bool,
	invalidMessage: PropTypes.string.isRequired,
	handleReferenceChange: PropTypes.func,
	disabled: PropTypes.bool,
	errorMessage: PropTypes.string,
};

export { Reference };
export default withValidation({
	validations: ['required', 'reference', 'minLength'],
	key: 'reference',
})(Reference);

export const BacsDebitRef = withValidation({
	validations: ['required', 'reference', 'minLength'],
	key: 'reference',
	message: {
		required: 'Enter a reference',
		reference: 'Enter a reference',
		minLength: `Reference must be at least ${bacsReferenceMinLength} characters`,
	},
})(Reference);
